///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.short_dated = abcsetup.short_dated || {};
abcsetup.short_dated.responses = abcsetup.short_dated.responses || {};
abcsetup.short_dated.responses.workflow = abcsetup.short_dated.responses.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.short_dated.responses.workflow = {

    init: function () {
        $(window).on('load', function() {
            // FIXME: This should be by workflow task, not class.
            if ($('#sd-pricing-sgs-review-form').length) {
                $('tr[data-item-id]').each(function() {
                    var id = $(this).data('item-id');
                    var radioValue = $('input[name="item[' + id + '][status]"]:checked').val();
                    var rejected_reason = $('#item-' + id + '-rejected-reason');
                    var rejected_reason_value = $('#item-' + id + '-rejected-reason').val();
                    var rejected_reason_other = $('#item-' + id + '-rejected-reason-other')
                    var purchase_price = $('#item-' + id + '-sgs-buy-price');
                    var sgs_team_price = $('#item-' + id + '-sgs-price');
                    var sgs_team_quantity = $('#item-' + id + '-sgs-quantity');

                    if (radioValue == 'rejected') {
                        $('item-' + id + '-rejected-reason').trigger('change');

                        rejected_reason.prop('disabled', false);
                        purchase_price.prop('disabled', true);
                        purchase_price.prop('required', false);
                        sgs_team_price.prop('disabled', true);
                        sgs_team_price.prop('required', false);
                        sgs_team_quantity.prop('disabled', true);
                        sgs_team_quantity.prop('required', false);

                        if(rejected_reason_value == 'Other') {
                            rejected_reason_other.prop('disabled', false).prop('required', true);
                        }

                    } else {
                        rejected_reason.prop('disabled', true).val('');
                        rejected_reason_other.prop('disabled', true).val('');
                        purchase_price.prop('disabled', false);
                        purchase_price.prop('required', true);
                        sgs_team_price.prop('disabled', false);
                        sgs_team_price.prop('required', true);
                        sgs_team_quantity.prop('disabled', false);
                        sgs_team_quantity.prop('required', true);
                    }
                });

                $('#sd-pricing-sgs-review-form .sgs-price').trigger('change');
                $('#sd-pricing-sgs-review-form .sgs-quantity').trigger('change');
                abcsetup.short_dated.responses.workflow.checkIfAllHaveStatus();
            }

            if ($('#counter-offer-form').length) {
                $('.pricing-counter-options').trigger('change');
            }
        });

        // Prevent Enter Key from submitting the form
        $("input").on("keypress", function (event) {
            if (event.key == 'Enter') {
                event.preventDefault();
                return false;
            }
        });

        $('form').on('submit', (e) => {
            abcsetup.blockUI(true);
        })

        // Disable required fields for SGS team on 'sgs_team_short_dated_opportunity_pricing_review' task when SGS team rejects an individual item
        $('.accept_reject').on('change', function(e) {
            var itemID = $(this).closest('tr').attr('data-item-id');

            if ($(this).val() == 'rejected') {
                $('input[id^="item-' + itemID + '-"]').prop('required', false);
                $(this).closest('tr').find('select').prop('required', true);
            } else {
                $('input[id^="item-' + itemID + '-"]').prop('required', true);
                $(this).closest('tr').find('select').prop('required', false);
            }
        });

        // Approve all items
        $('.approve-all').on('click', function(e) {
            $('#'+$(this).data('table') +' input[value="accepted"]').prop('checked', true);
            $('.rejected-reason').val('').prop('disabled', true);
            $('.rejected-other-reason').val('').prop('disabled', true);
            $('.sgs-price').prop('disabled', false).prop('required', true);
            $('.sgs-quantity').prop('disabled', false).prop('required', true);
        });

        // Reject all items if universal reason can be given
        $('.reject-all').on('click', function(e) {
            var reason = '';

            $('#opportunity-review-table input[value="rejected"]').prop('checked', true);

            if ($('#item-reject-all-reason').val() != 'Other') {
                reason = $('#item-reject-all-reason').val();
                $('#opportunity-review-table .rejected-reason').val(reason);
                $('#opportunity-review-table .rejected-reason').prop('disabled', false);
            } else {
                reason = $('#item-rejected-all-reason-other').val();
                $('#opportunity-review-table .rejected-reason').val('Other');
                $('#opportunity-review-table .rejected-other-reason').prop('disabled', false);
                $('#opportunity-review-table .rejected-other-reason').val(reason);
            }

            $('.sgs-price').val('').prop('disabled', true).prop('required', false);
            $('.sgs-quantity').val('').prop('disabled', true).prop('required', false);
            $('.price-warning').hide();
            $('.quantity-warning').hide();

            $('#rejectAllModal').modal('hide');
        });


        // Clear out other reasons when dropdown in modal is changed
        $('#item-reject-all-reason').on('change', function(e) {
            if ($('#item-reject-all-reason').val() != 'Other') {
                $('#item-rejected-all-reason-other').val('');
                $('#opportunity-review-table .rejected-other-reason').val('');
            } else {
                $('#other-reason-all').show();
            }
        });

        // Clear out values when Reject All button is Pushed
        $('.btn-reject-all').on('click', function(e) {
            $('#item-reject-all-reason').val('');
            $('#item-rejected-all-reason-other').val('');
        });

        // Reject all items - Short Dated Pricing Team
        $('.reject-all-pricing').on('click', function(e) {
            $('#'+$(this).data('table')+' input[value="rejected"]').trigger('click');
        });

        // Counter all items - Short Dated Pricing Team
        $('.counter-all').on('click', function(e) {
            $('#'+$(this).data('table')+' input[value="pricing_countered"]').trigger('click');
        });

        // Offer letter: make the import button disabled until a file was selected
        $('#offer_letter').on('change', function(){
            if ($(this)[0].files.length === 0) {
                $('#offer_letter_import_button').addClass('disabled').prop('disabled', true);
            } else {
                $('#offer_letter_import_button').removeClass('disabled').prop('disabled', false);
            }
        });

        // Validate sgs approve/reject of new items
        $('#opportunity-review-form').on('submit', function(e) {
            var valid = true;
            $('tr[data-item-id]').each(function() {
                var id = $(this).data('item-id');
                var checked_action = $('input[name="item-'+id+'"]:checked');
                var rejected_reason = $('#item-'+id+'-rejected-reason');

                if (checked_action.val() === undefined) {
                    valid = false;
                } else if (checked_action.val() === 'rejected' && rejected_reason.val() === '') {
                    valid = false;
                }
            });

            if (!valid) {
                e.preventDefault();
                abcsetup.alerts.show('Form Validation', 'You must approve or reject all items to proceed');
                return;
            }
        });

        // Items are being imported from an excel document
        $(document).on("click", "#sgs_import_template_button", function () {
            abcsetup.blockUI(true);
            abcsetup.excel.readFile($("#update_items_import")[0], function(data) {
                var rows = abcsetup.excel.toArray(data, abcsetup.short_dated_opportunity.common.sgs_column_map);

                // Loop through newly created rows to pop item into the UI
                for (var i in rows) {
                    // var validate = abcsetup.short_dated_opportunity.common.validateSGSNewItem(rows[i]);

                    // if (!validate.valid) {
                    //     abcsetup.alerts.show('Import Error', 'Please correct ' + validate.field + ' on line ' + (parseInt(i, 10) + 2));
                    //     return;
                    // }
                }

                for (var i in rows) {
                    var id = rows[i].id;
                    var status = rows[i].status;
                    var decline_reason = rows[i].decline_reason;

                    $('#item-' + id + '-' + status).trigger('click');

                    if (status == 'rejected') {
                        $('#item-' + id + '-rejected-reason').val(decline_reason);
                    }

                }

                abcsetup.unblockUI();
            }, true);

            $("#update_items_import").val('').trigger('change');
        });

        // SD Pricing Team Additional Review - Auto fill buttons based on file import
        $(document).on("click", "#pricing_team_additional_review_import_button", function () {
            abcsetup.blockUI(true);
            abcsetup.excel.readFile($("#additional_pricing_update_items_import")[0], function(data) {
                var rows = abcsetup.excel.toArray(data, abcsetup.short_dated_opportunity.common.pricing_column_map);

                // Loop through newly created rows to pop item into the UI
                for (var i in rows) {
                    var id = rows[i].id;
                    var status = rows[i].status;
                    var sell_price = rows[i].sell_price;

                    $('#item-' + id + '-' + status).trigger('click');

                    if (status == 'pricing_countered') {
                        $('#item-' + id + '-pricing-counter-price').val(sell_price);
                    }
                }

                abcsetup.unblockUI();
            }, true);

            $("#additional_pricing_update_items_import").val('').trigger('change');
        });

        // SD Pricing Team Opportunity Review - Auto fill fields based on file import
        // Items are being imported from an excel document
        $(document).on("click", "#sd_pricing_opportunity_review_import_button", function () {
            abcsetup.blockUI(true);
            abcsetup.excel.readFile($("#update_items_import")[0], function(data) {
                var rows = abcsetup.excel.toArray(data, abcsetup.short_dated_opportunity.common.pricing_op_review_column_map);
                for (var i in rows) {
                    var id = rows[i].id;
                    var sell_price = parseFloat(rows[i].sell_price).toFixed(2);
                    var premier_price = parseFloat(rows[i].premier_price).toFixed(2);
                    var hpg_price = parseFloat(rows[i].hpg_price).toFixed(2);
                    var vizient_price = parseFloat(rows[i].vizient_price).toFixed(2);
                    var pricing_team_comments = rows[i].pricing_team_comments;

                    $('#item_' + id + '_sell_price').val(sell_price);
                    $('#item_' + id + '_premier_price').val(premier_price);
                    $('#item_' + id + '_hpg_price').val(hpg_price);
                    $('#item_' + id + '_vizient_price').val(vizient_price);
                    $('#item_' + id + '_pricing_team_comments').val(pricing_team_comments);
                }

                abcsetup.unblockUI();
            }, true);

            $("#update_items_import").val('').trigger('change');
        });

        // SGS Team Offer Letter - Auto fill fields based on file import
        // Items are being imported from an excel document
        $(document).on("click", "#sgs_offer_letter_import_button", function () {
            abcsetup.blockUI(true);
            abcsetup.excel.readFile($("#update_items_import")[0], function(data) {
                var rows = abcsetup.excel.toArray(data, abcsetup.short_dated_opportunity.common.sgs_offer_letter_column_map);
                for (var i in rows) {
                    var id = rows[i].id;
                    var distribution = rows[i].distribution;
                    var wac_price = rows[i].wac_price;
                    var contract_chargeback = rows[i].contract_chargeback;
                    var contract_cost = rows[i].contract_cost;
                    var billback_purchase_credit = rows[i].billback_purchase_credit;
                    var chargeback = rows[i].chargeback;
                    var buyside_fees = rows[i].buyside_fees;
                    var payment_disc = rows[i].payment_disc;
                    var deadnet = rows[i].deadnet;
                    var buy_request_date = rows[i].buy_request_date;
                    var purchase_inventory = rows[i].purchase_inventory;
                    var note = rows[i].note;

                    $('#item_' + id + '_distribution').val(distribution);
                    $('#item_' + id + '_wac_price').val(wac_price);
                    $('#item_' + id + '_contract_chargeback').val(contract_chargeback);
                    $('#item_' + id + '_contract_cost').val(contract_cost);
                    $('#item_' + id + '_billback_purchase_credit').val(billback_purchase_credit);
                    $('#item_' + id + '_chargeback').val(chargeback);
                    $('#item_' + id + '_buyside_fees').val(buyside_fees);
                    $('#item_' + id + '_payment_disc').val(payment_disc);
                    $('#item_' + id + '_deadnet').val(deadnet);
                    $('#item_' + id + '_buy_request_date').val(moment(buy_request_date, "YYYY-MM-DD").format('YYYY-MM-DD'));
                    $('#item_' + id + '_purchase_inventory').val(purchase_inventory);
                    $('#item_' + id + '_note').val(note);
                }

                abcsetup.unblockUI();
            }, true);

            $("#update_items_import").val('').trigger('change');
        });

        // SGS Team Pricing Review - Auto fill fields based on file import
        // Items are being imported from an excel document
        $(document).on("click", "#sgs_pricing_review_import_button", function () {
            abcsetup.blockUI(true);
            abcsetup.excel.readFile($("#update_items_import")[0], function(data) {
                var rows = abcsetup.excel.toArray(data, abcsetup.short_dated_opportunity.common.sgs_pricing_review_column_map);
                var approvedItems = [];
                var rejectedItems = [];

                for (var i in rows) {
                    var id = rows[i].id;
                    var status = rows[i].status;
                    var decline_reason = rows[i].decline_reason;
                    var decline_reason_other = rows[i].decline_reason_other;
                    var buy_price = rows[i].buy_price;
                    var price = rows[i].price;
                    var quantity = rows[i].quantity;

                    if (status == 'accepted') {
                        approvedItems.push(id);
                    }

                    if (status == 'rejected') {
                        rejectedItems.push(id);
                    }

                    $('#item-' + id + '-rejected-reason').val(decline_reason);
                    $('#item-' + id + '-rejected-reason').trigger('change');
                    $('#item-' + id + '-rejected-reason-other').val(decline_reason_other);
                    $('#item-' + id + '-sgs-buy-price').val(buy_price);
                    $('#item-' + id + '-sgs-price').val(price);
                    $('#item-' + id + '-sgs-quantity').val(quantity);
                }

                $.each(approvedItems, function( index, value ) {
                    $('#item-' + value + '-accepted').prop('checked', true);
                });

                $.each(rejectedItems, function( index, value ) {
                    $('#item-' + value + '-rejected').prop('checked', true);
                    $('#item-' + value + '-rejected-reason').prop('disabled', false);
                    $('#item-' + value + '-sgs-price').val('').prop('disabled', true).prop('required', false);
                    $('#item-' + value + '-sgs-quantity').val('').prop('disabled', true).prop('required', false);
                });

                $('#sd-pricing-sgs-review-form .sgs-price').trigger('change');
                $('#sd-pricing-sgs-review-form .sgs-quantity').trigger('change');

                // Trigger a change event on a single item approve/reject radio, in order to properly check on the item statuses after an import (to disable/enable the submit button)
                var first_item_id = $('tr[data-item-id]').attr("data-item-id");
                var radioValue = $('input[name="item[' + first_item_id + '][status]"]:checked').val();
                $('input[name="item[' + first_item_id + '][status]"]:checked').val(radioValue).trigger('change');

                abcsetup.unblockUI();
            }, true);

            $("#update_items_import").val('').trigger('change');
            abcsetup.short_dated.responses.workflow.checkIfAllHaveStatus();
        });

        $(document).on("click", "#rx_vendor_short_dated_opportunity_counter_review_import_button", function () {
            abcsetup.blockUI(true);
            abcsetup.excel.readFile($("#update_items_import")[0], function(data) {
                var rows = abcsetup.excel.toArray(data, abcsetup.short_dated_opportunity.common.rx_vendor_counter_review_column_map);
                for (var i in rows) {
                    var id = rows[i].id;
                    var counter_options = rows[i].counter_options;
                    var counter_price = parseFloat(rows[i].counter_price).toFixed(2);
                    var counter_quantity = rows[i].counter_quantity;
                    var vendor_comments = rows[i].vendor_comments;

                    $('#item_' + id + '_select').prop('checked', true);
                    $('#item_' + id + '_counter_options').val(counter_options).trigger('change');
                    $('#item_' + id + '_price').val(counter_price);
                    $('#item_' + id + '_counter_price').val(parseFloat(counter_price));
                    $('#item_' + id + '_quantity').val(counter_quantity);
                    $('#item_' + id + '_vendor_comments').val(vendor_comments);
                }

                abcsetup.unblockUI();
            }, true);

            $("#update_items_import").val('').trigger('change');
        });

        // Toggle rejection reason(s) editability
        $('#sd-pricing-sgs-review-form input[type="radio"]').on('change', function() {
            var id = $(this).parents('tr').data('item-id');
            var rejected_reason = $('#item-' + id + '-rejected-reason');
            var rejected_reason_other = $('#item-' + id + '-rejected-reason-other')
            var purchase_price = $('#item-' + id + '-sgs-buy-price');
            var sgs_team_price = $('#item-' + id + '-sgs-price');
            var sgs_team_quantity = $('#item-' + id + '-sgs-quantity');

            if ($(this).val() === 'rejected') {
                $('item-' + id + '-rejected-reason').trigger('change');
                rejected_reason.prop('disabled', false);
                purchase_price.prop('disabled', true);
                purchase_price.prop('required', false);
                sgs_team_price.prop('disabled', true);
                sgs_team_price.prop('required', false);
                sgs_team_quantity.prop('disabled', true);
                sgs_team_quantity.prop('required', false);
                //trigger('focus');
            } else {
                rejected_reason.prop('disabled', true).val('');
                rejected_reason_other.prop('disabled', true).val('');
                purchase_price.prop('disabled', false);
                purchase_price.prop('required', true);
                sgs_team_price.prop('disabled', false);
                sgs_team_price.prop('required', true);
                sgs_team_quantity.prop('disabled', false);
                sgs_team_quantity.prop('required', true);
            }

            abcsetup.short_dated.responses.workflow.checkIfAllHaveStatus();

        });

        // Toggle rejection reason other editability
        $('#sd-pricing-sgs-review-form select').on('change', function() {
            var rejected_reason_other = $('#'+$(this).attr('id')+'-other');
            if ($(this).val() === 'Other') {
                rejected_reason_other.prop('disabled', false);
                rejected_reason_other.prop('required', true);
                //trigger('focus');
            } else {
                rejected_reason_other.prop('disabled', true).val('');
                rejected_reason_other.prop('required', false);
            }
        });

        // Toggle SD Pricing Team's counter editability
        $('#sd-pricing-price-team-form input[type="radio"]').on('change', function() {
            var pricing_counter_price = $('#'+$(this).attr('name')+'-pricing-counter-price');
            if ($(this).val() === 'pricing_countered') {
                pricing_counter_price.prop('disabled', false);
            } else {
                pricing_counter_price.prop('disabled', true).val('');
            }
        });

        // Toggle SD Pricing Team's counter price and quantity editability
        $('#workflow-form select').on('change', function() {
            var id = $(this).parents('tr').data('item-id');
            var pricing_counter_review_price = $('#item_' + id + '_price');
            var pricing_counter_review_quantity = $('#item_' + id + '_quantity');
            var counter_price = false;
            if ($(this).val() === 'new_price' || $(this).val() === 'Counter Deal' || $(this).val() === 'Counter To Supplier') {
                pricing_counter_review_price.prop('disabled', false);
                pricing_counter_review_price.prop('required', true);
                pricing_counter_review_quantity.prop('disabled', false);
                pricing_counter_review_quantity.prop('required', true);
            } else if ($(this).val() === 'Pricing Team Review') {
                pricing_counter_review_price.prop('disabled', false).prop('required', false);
                pricing_counter_review_quantity.prop('disabled', false).prop('required', false);
            } else {
                pricing_counter_review_price.prop('disabled', true).val('');
                pricing_counter_review_price.prop('required', false);
                pricing_counter_review_quantity.prop('disabled', true).val('');
                pricing_counter_review_quantity.prop('required', false);
            }
            $(".pricing-counter-options").each(function( index ) {
                if ($(this).val() === 'Counter Deal') {
                    counter_price = true;
                }
            });

            if (counter_price) {
                $('#counter-approve-button').prop('disabled', true);
            } else {
                $('#counter-approve-button').prop('disabled', false);
            }
        });

        // Validate sgs review of pricing team's submission
        $('#sd-pricing-sgs-review-form').on('submit', function(e) {
            var valid = true;
            $('tr[data-item-id]').each(function() {
                var id = $(this).data('item-id');
                var item_sgs_buy_price = $('#item-'+id+'-sgs-buy-price');
                var item_sgs_price = $('#item-'+id+'-sgs-price');
                var item_sgs_quantity = $('#item-'+id+'-sgs-quantity');

                if (isNaN(parseFloat(item_sgs_price.val())) || parseFloat(item_sgs_price.val()) <= 0) {
                    item_sgs_price.addClass('invalid');
                    valid = false;
                    console.log('bad', id);
                }

                if (isNaN(parseInt(item_sgs_quantity.val(), 10)) || parseInt(item_sgs_quantity.val(), 10) <= 0) {
                    item_sgs_quantity.addClass('invalid');
                    valid = false;
                    console.log('bad', id);
                }
            });

            if (!valid) {
                e.preventDefault();
                abcsetup.alerts.show('Form Validation', 'Price(s) must valid and greater than 0.00 and quantities must be greater than 0');
                return;
            }
        });

        // Validate items being submitted to see if supplier is required to upload offer letter
        $('#submitButton').on('click', function(e) {
            if (abcsetup.userRole.class == 'rx_vendor' && $('#workflow_task').val() == 'rx_vendor_short_dated_opportunity_counter_review') {
                $('#offer_letter').prop('required', false)

                if (!$('#offer_letter').val() && !$('.offer-letter-exists').length) {
                    var totalItems = $('.pricing-counter-options').length;

                    var approvedItems = $('.pricing-counter-options').filter(function() {
                        return $(this).length > 0 &&
                        $(this).val() == 'Accept Deal';
                    }).length;

                    var rejectedItems = $('.pricing-counter-options').filter(function() {
                        return $(this).length > 0 &&
                        $(this).val() == 'Reject Deal';
                    }).length;

                    var anyApproved = $('.item-status').filter(function() {
                        return $(this).text().indexOf('Approved') > -1;
                    }).length;

                    // Allow submit when all items are being rejected
                    if (((totalItems == (approvedItems + rejectedItems)) && approvedItems > 0) || (totalItems == 0 && anyApproved > 0)) {
                        $('#offer_letter').prop('required', true);
                        $('#offer_letter').addClass('invalid');
                        abcsetup.alerts.show('Offer Letter Required', 'At this point all of your items have been given a final disposition. Please upload an Offer Letter in PDF Format.');
                    }
                }
            }
        });

        $('input[name="ids[]"]').on('click change', function() {
            if ($(this).is(":checked")) {
                $('#item_' + $(this).val() + '_counter_options').prop('required', true);
            } else {
                $('#item_' + $(this).val() + '_counter_options').prop('required', false);
            }
        });

        $('#update_items_import').on('change', function(){
            if ($(this)[0].files.length === 0) {
                $('#pricing_team_import_button').addClass('disabled').prop('disabled', true);
            } else {
                $('#pricing_team_import_button').removeClass('disabled').prop('disabled', false);
            }
        });

        // SD Pricing Team additional review step import
        $('#additional_pricing_update_items_import').on('change', function(){
            if ($(this)[0].files.length === 0) {
                $('#pricing_team_additional_review_import_button').addClass('disabled').prop('disabled', true);
            } else {
                $('#pricing_team_additional_review_import_button').removeClass('disabled').prop('disabled', false);
            }
        });

        $('#update_items_import').on('change', function(){
            if ($(this)[0].files.length === 0) {
                $('#sd_pricing_opportunity_review_import_button').addClass('disabled').prop('disabled', true);
            } else {
                $('#sd_pricing_opportunity_review_import_button').removeClass('disabled').prop('disabled', false);
            }
        });

        $('#update_items_import').on('change', function(){
            if ($(this)[0].files.length === 0) {
                $('#sgs_offer_letter_import_button').addClass('disabled').prop('disabled', true);
            } else {
                $('#sgs_offer_letter_import_button').removeClass('disabled').prop('disabled', false);
            }
        });

        $('#update_items_import').on('change', function(){
            if ($(this)[0].files.length === 0) {
                $('#sgs_pricing_review_import_button').addClass('disabled').prop('disabled', true);
            } else {
                $('#sgs_pricing_review_import_button').removeClass('disabled').prop('disabled', false);
            }
        });

        $('#update_items_import').on('change', function(){
            if ($(this)[0].files.length === 0) {
                $('#rx_vendor_short_dated_opportunity_counter_review_import_button').addClass('disabled').prop('disabled', true);
            } else {
                $('#rx_vendor_short_dated_opportunity_counter_review_import_button').removeClass('disabled').prop('disabled', false);
            }
        });

        // SGS Team pricing review import
        $('#update_items_import').on('change', function(){
            if ($(this)[0].files.length === 0) {
                $('#sgs_priced_items_import_button').addClass('disabled').prop('disabled', true);
            } else {
                $('#sgs_priced_items_import_button').removeClass('disabled').prop('disabled', false);
            }
        });

        // Validate pricing team submission
        $('#sd-pricing-price-team-form').on('submit', function(e) {
            var valid = true;
            var rows = $('#app_data_tables_short_dated_opportunity_workflow_data_table tbody tr');

            $('td.invalid').removeClass('invalid');

            rows.each(function() {
                var buy_price = $(this).children('.buy_price');
                var sell_price = $(this).children('.sell_price');

                //console.log(buy_price.text());

                if (isNaN(parseFloat(buy_price.text())) || parseFloat(buy_price.text()) <= 0) {
                    buy_price.addClass('invalid');
                    valid = false;
                }

                if (isNaN(parseFloat(sell_price.text())) || parseFloat(sell_price.text()) <= 0) {
                    sell_price.addClass('invalid');
                    valid = false;
                }
            });

            if (!valid) {
                e.preventDefault();
                abcsetup.alerts.show('Form Validation', 'Price(s) must valid and greater than 0.00');
                return;
            }
        });

        // Validate pricing team submission
        $('#sd-pricing-vendor-form').on('submit', function(e) {
            //e.preventDefault();
            console.log(document.activeElement.value);
            // for (var i in e.target.elements) {
            //     //console.log(i, e.target.elements[i]);
            // }

            return;
        });

        // Validate pricing team submission
        $('#sd-pricing-sgs-team-form').on('submit', function(e) {

            if (document.activeElement.value === 'reject') {
                console.log('reject');
            }

            //e.preventDefault();
            //return;
        });

        // Rejection button was clicked
        $('#complete-opportunity-form #reject').on('click', function(e) {
            abcsetup.alerts.confirm('Reject Submission', 'Are you sure you want to reject this submission?', function(confirm) {
                if (confirm) {
                    $('#form_action').val('reject');
                    $('#complete-opportunity-form').trigger('submit');
                } else {
                    $('#form_action').val('approve');
                }
            }, 'Reject', 'btn-danger');
        });

        $('#offer_letter').on('change' ,function(){
            var fileName = $(this).val();
            $(this).closest('.custom-file').find('.custom-file-label').html(fileName);
        })

        abcsetup.short_dated.responses.workflow.offerLetterDisplay();


        // Warn SGS user is entered quantity value is higher than the available quantity set by the supplier
        $('#sd-pricing-sgs-review-form .sgs-quantity').on('change', function() {
            var itemID = $(this).closest('tr').attr('data-item-id');
            $('#' + itemID + '_quantity_warning').html('');

            if ($(this).val() != '' && ($(this).val() > $(this).data('available-quantity'))) {
                $('#' + itemID + '_quantity_warning').html('Higher than supplier available: ' + $(this).data('available-quantity'));
                $('#' + itemID + '_quantity_warning').show();
            } else if ($(this).val() != '' && ($(this).val() < $(this).data('available-quantity')))  {
                $('#' + itemID + '_quantity_warning').html('Lower than supplier available: ' + $(this).data('available-quantity'));
                $('#' + itemID + '_quantity_warning').show();
            } else {
                $('#' + itemID + '_quantity_warning').hide();
            }
        });

        // Warn SGS user if entered quantity value is higher than the price set by the supplier
        $('#sd-pricing-sgs-review-form .sgs-price').on('change', function() {
            var itemID = $(this).closest('tr').attr('data-item-id');
            $('#' + itemID + '_price_warning').html('');

            if ($(this).val() != '' && ($(this).val() > $(this).data('supplier-price'))) {
                $('#' + itemID + '_price_warning').html('Higher than Supplier suggested: $' + $(this).data('supplier-price'));
                $('#' + itemID + '_price_warning').show();
            } else if ($(this).val() != '' && ($(this).val() < $(this).data('supplier-price')))  {
                $('#' + itemID + '_price_warning').html('Lower than Supplier suggested: $' + $(this).data('supplier-price'));
                $('#' + itemID + '_price_warning').show();
            } else {
                $('#' + itemID + '_price_warning').hide();
            }
        });
    },

    fieldsInit: function () {
        //Bind any fields events
    },

    uploadDone(x) {
        //console.log('done', x, abcsetup.uploader.uploadResult);

        if (abcsetup.uploader.uploadResult.hasOwnProperty('file')) {
            $('#offer-letter-final').val(abcsetup.uploader.uploadResult.file);
        }

        abcsetup.short_dated.responses.workflow.offerLetterDisplay();

        // if (abcsetup.uploader.uploadResult.type === 'importSuppliers') {
        //     abcsetup.consumer_rfp.common.importSuppliers(abcsetup.uploader.uploadResult.vals);
        // } else if (abcsetup.uploader.uploadResult.type === 'importItems') {
        //     abcsetup.consumer_rfp.common.importItems(abcsetup.uploader.uploadResult.vals, abcsetup.uploader.uploadResult.extras);
        // }
    },

    /**
     * Correct displays for offer letters
     */
    offerLetterDisplay: function() {
        if ($('#offer-letter')[0] && $('#offer-letter-container')[0]) {
            var path = $('#offer-letter').val();
            var fileinfo = abcsetup.short_dated.responses.workflow.getFileInfo(path);

            if (fileinfo.file_name.length > 0 && fileinfo.file_ext.length > 0) {
                $('#offer-letter-container h6').text(fileinfo.file_name + '.' + fileinfo.file_ext);
                $('#offer-letter-container .offer-letter-icon').removeClass('fa-file').addClass('fa-file-'+fileinfo.file_ext)
                $('#offer-letter-container .btn.disabled').removeClass('disabled');
                $('#offer-letter-container').addClass('complete');
            }
        }

        if ($('#offer-letter-final')[0] && $('#offer-letter-final-container')[0]) {
            var path = $('#offer-letter-final').val();
            var fileinfo = abcsetup.short_dated.responses.workflow.getFileInfo(path);

            if (fileinfo.file_name.length > 0 && fileinfo.file_ext.length > 0) {
                $('#offer-letter-final-container h6').text(fileinfo.file_name + '.' + fileinfo.file_ext);
                $('#offer-letter-final-container .offer-letter-icon').removeClass('fa-file').addClass('fa-file-'+fileinfo.file_ext)
                $('#offer-letter-final-container .btn.disabled').removeClass('disabled');
                $('#offer-letter-final-container').addClass('complete');
            }
        }

        if ($('#workflow_task').val() == 'sgs_team_short_dated_offer_letter') {
            // Disable the approve button while there is no signed final offer letter uploaded
            if ($('#offer-letter-final-container').hasClass('complete')) {
                $('#submitButton').prop('disabled', false);
                $('#submitButton').prop('title', 'Click to approve submission');
            } else {
                $('#submitButton').prop('disabled', true);
                $('#submitButton').prop('title', 'Please upload a signed final offer letter first');
            }
        }
    },

    /**
     * File info for offer letters
     */
    getFileInfo: function(path) {

        var file_name = '';
        var file_ext = '';
        var path_arr = path.split('/');
        var file = path_arr[path_arr.length-1];
        var file_name_arr = file.split('.');

        if (file_name_arr[0]) {
            file_name = file_name_arr[0];

            if (file_name.length > 10) {
                file_name = file_name.substring(0, 5) + '...' + file_name.substring(file_name.length - 6);
            }
        }

        if (file_name_arr[1]) {
            file_ext = file_name_arr[1]
        }

        return {
            file_name: file_name,
            file_ext: file_ext,
        }
    },

    checkIfAllHaveStatus: function() {
        var canSubmit = true;

        $('tr[data-item-id]').each(function() {
            var id = $(this).data('item-id');
            var radioValue = $('input[name="item[' + id + '][status]"]:checked').val();

            if (radioValue == undefined) {
                canSubmit = false;
            }
        });

        if (canSubmit == false) {
            $('#submitButton').prop('disabled', true);
        } else {
            $('#submitButton').prop('disabled', false);
        }
    }
}
